import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"

export function useVerticalSigningMutation(
    url,
    axiosFn,
    queryParameters,
    config = {},
) {
    const apiUrl = `vertical_signing/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        queryParameters,
        config,
    )
}